import {orderBy, countBy} from 'lodash'
import clsx from 'clsx'
import React from 'react'
import {useHistory} from 'react-router-dom'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '../../responsive-fullscreen-dialog'
import {findGlobalIndex} from './utils'

const useStyles = makeStyles(finalizeAssessmentStyles)

export default function FinalizeAssessment ({isOpen, onClose, context, imported}) {

  const history = useHistory()
  const [error, setError] = React.useState('')
  const [submitting, setSubmitting] = React.useState(false)
  const classes = useStyles() 
  const {translate, quizAssessmentToTake: assessment, assessment: assessmentId, saveAnswers} = context
  const {content = {}} = assessment 

  const sections = !context.quizSearch['assessment-to-take']
    ? orderBy(Object.values(content.sections || {}), 'index')
    : []

  const answers = Object.entries(assessment.answers || {}).map(([id, {completed, pending}]) => ({completed, pending, globalIndex: findGlobalIndex(id, sections)}))

  const completed = answers.filter(a => !a.pending && a.completed)

  const unanswered = orderBy(answers.filter(a => !a.pending && !a.completed), 'globalIndex').map(a => a.globalIndex + 1)
  const pending = orderBy(answers.filter(a => a.pending), 'globalIndex').map(a => a.globalIndex + 1)

  async function handleFinalize() {
    if (imported || context.attemptId) {
      const onFinalize = (imported && imported.onFinalize) || context.importedFinalize
      if (typeof onFinalize !== 'function') {
        setError('No se pudo identificar la finalización de la prueba importada.')
        return
      }
      if (submitting) return
      setSubmitting(true)
      setError('')
      try {
        await onFinalize()
        onClose()
      } catch (e) {
        setError('No se pudo finalizar la prueba. Inténtalo nuevamente.')
      } finally {
        setSubmitting(false)
      }
      return
    }
    const [savedId] = await saveAnswers({id: assessmentId, answers: assessment.answers, finalize: true})
    if (assessment.id == savedId) {
      onClose()
      context.navigate({action: 'preview-results', sectionId: undefined, questionId: undefined})
    }
  }

  return (
    <Dialog
      open={isOpen}
      close={onClose}
      actionsClassName={classes.actions}
      confirm={
        <Button
          variant="contained"
          className={clsx("button", "create")}
          color="primary"
          disabled={submitting}
          onClick={handleFinalize}>
            {translate('finalize')}
        </Button>
      }
      cancel={
        <Button
          variant="contained"
          className={clsx("button", "cancel")}
          onClick={onClose}>
            {translate('cancel')}
        </Button>
      }
      title={translate('finalize-dialog-title')}
    >
      {error && <Box role="alert">{error}</Box>}
      <Box className={classes.completed}>{translate('finalize-dialog-completed-message', {completed: completed.length, total: answers.length})}</Box>
      {pending.length > 0 && <Box className={classes.pending}>{translate('finalize-dialog-pending-message', {pending: pending.join(', ')})}</Box>}
      {unanswered.length > 0 && <Box className={classes.unanswered}>{translate('finalize-dialog-unanswered-message', {unanswered: unanswered.join(', ')})}</Box>}
    </Dialog>
  )
}

function finalizeAssessmentStyles(theme) {
  return {
  }
}
